import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import pt from "./locales/pt.json";
import sw from "./locales/sw.json";
import es from "./locales/es.json";

// Right-to-left languages (Arabic, Hebrew, etc.). Extend as needed.
export const RTL_LANGS = new Set(["ar", "he", "fa", "ur"]);

// Supported languages published in the UI.
// Each language is represented by its native name + flag.
// Note : ar / pt / sw / es fournissent une couverture partielle (nav + hero + CTA)
// — les clés non traduites tombent automatiquement en français via fallbackLng.
export const SUPPORTED_LANGS = [
  { code: "fr", label: "Français",   nativeLabel: "Français",   flag: "🇫🇷" },
  { code: "en", label: "English",    nativeLabel: "English",    flag: "🇬🇧" },
  { code: "ar", label: "Arabic",     nativeLabel: "العربية",   flag: "🇸🇦" },
  { code: "pt", label: "Portuguese", nativeLabel: "Português",  flag: "🇵🇹" },
  { code: "sw", label: "Swahili",    nativeLabel: "Kiswahili",  flag: "🇰🇪" },
  { code: "es", label: "Spanish",    nativeLabel: "Español",    flag: "🇪🇸" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ar: { translation: ar },
      pt: { translation: pt },
      sw: { translation: sw },
      es: { translation: es },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en", "ar", "pt", "sw", "es"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "africtal_lang",
    },
    react: { useSuspense: false },
  });

// Sync <html lang="…" dir="…"> whenever language changes
function applyHtmlAttributes(lng) {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
    document.documentElement.dir = RTL_LANGS.has(lng) ? "rtl" : "ltr";
  }
}
applyHtmlAttributes(i18n.language || "fr");
i18n.on("languageChanged", applyHtmlAttributes);

export default i18n;
